import React, { useEffect } from 'react'
import MainCalculatorContainer from '../containers/MainCalculator'

const MainCalculator: React.FC= () => {

  useEffect(()=>{
    document.title = ''
  }, [])

  return (
    <div>
      <MainCalculatorContainer />
    </div>
  )
}

export default MainCalculator